import React, { useState } from "react";
import { Badge, Button, Modal } from "react-bootstrap";
import moment from "moment";
import axios from "axios";
import "./BuilderEsign.css";

type DocumentRowProps = {
  FileName: string;
  Timestamp: string;
  onStartEsigning?: (msgID: string, fileName: string, remoteSigning?: boolean) => void;
  msgID: string;
  note: string;
  signStatus: boolean;
  sid: string;
  displayMode?: boolean;
  onCheckboxChange?: (isChecked: boolean) => void;
  JuratPackageList?: string[];
  StartinpesonJurat?: (fileName: string) => void;
  selectedPosts?: string[];
};

const BuilderDocumentRow = ({
  FileName,
  Timestamp,
  signStatus,
  note,
  onStartEsigning,
  msgID,
  sid,
  displayMode,
  onCheckboxChange,
  JuratPackageList,
  StartinpesonJurat,
  selectedPosts
}: DocumentRowProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [viewNote, setViewNote] = useState(false);
  const handleDownloadClick = async () => {
    setIsLoading(true);
    await handleDownload(msgID, FileName, sid);
    setIsLoading(false);
  };

  const handlePreviewClick = async () => {
    setIsPreviewLoading(true);
    await handlePreview(msgID, FileName, sid);
    setIsPreviewLoading(false);
  };

  const handleEsigningClick = async () => {
    setIsLoading(true);
    if (JuratPackageList && JuratPackageList.includes(FileName)) {
      await StartinpesonJurat(FileName);
    }else{
      await onStartEsigning(msgID, FileName, false);
    }
    setIsLoading(false);
  };

  function dateStr(timeStr: string): string {
    return moment(timeStr).utc().format("YYYY-MM-DD HH:mm:ss");
  }

  return (
    <>
      <tr>
        <td>
        {displayMode && <input
            type="checkbox"
            defaultChecked={selectedPosts?.includes(FileName)}
            onChange={(e) => onCheckboxChange(e.target.checked)}
          />}
          {!displayMode && <i className="fa-solid fa-file-pdf"></i>}
        </td>
        <td>{FileName.replace(".pdf", "")}</td>
        <td>
          {signStatus && signStatus.toString() === "1" ? (
            <Badge bg="success" pill>
              Signed
            </Badge>
          ) : (
            <Badge bg="warning" pill>
              Not Signed
            </Badge>
          )}
        </td>
        <td>
          <i
            className={`fa-regular fa-message-lines ${note === "" ? 'disabled-icon' : ''}`}
            onClick={note !== "" ? () => setViewNote(true) : undefined}
            title={note !== "" ? "View vendor's Note." : 'No note for this posting.'}
          ></i>
        </td>
        <td>
          <Badge bg="secondary" text="dark" pill>
            {dateStr(String(Timestamp))}
          </Badge>
        </td>
        {!displayMode && (
          <>
            <td>
              <Button variant="link-text" onClick={handlePreviewClick}>
                <i className="fa-regular fa-arrow-down-to-line"></i>
                {isPreviewLoading ? "Loading.." : "Review"}
              </Button>
            </td>

            <td>
              {signStatus && signStatus.toString() === "1" ? (  
                <Button
                  variant="link-text"
                  onClick={handleDownloadClick}
                  disabled={isLoading}
                >
                  <i className="fa-solid fa-download"></i>
                  {isLoading ? "Loading..." : "Signed Package"}
                </Button>
              ) : (
                <Button
                  variant="link-text"
                  onClick={handleEsigningClick}
                  disabled={isLoading}
                >
                  <i className="fa-solid fa-signature"></i>
                  {isLoading ? "Loading.." : "Start In-Person eSigning"}
                </Button>
              )}
            </td>
          </>
        )}
      </tr>
      {viewNote && 
        <Modal show={viewNote}>
          <Modal.Header className="view-note-header">
              <Modal.Title>{FileName.replace(".pdf", "")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
              <p>{note}</p>
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-end">
              <Button onClick={() => setViewNote(false)}>
                  Done
              </Button>
          </Modal.Footer>
        </Modal>
      }
    </>
  );
};

const handlePreview = async (msgId: string, filename: string, sessionId: string) => {
  try {
    const baseURL = window.location.origin;
    const response = await axios.post(
      `${baseURL}/docsigning/sign/preview/${msgId}?SessionID=${sessionId}`,
      { files: [filename] },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    // Extract the buffer data from the response
    const bufferData = response.data.data[0][1].data;

    // Convert the buffer data to a Uint8Array
    const pdfData = new Uint8Array(bufferData);

    // Create a blob from the Uint8Array
    const blob = new Blob([pdfData], { type: "application/pdf" });

    // Create a link to download the blob
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename.replace(".pdf", "") + "_review.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error fetching preview:", error);
  }
};

const handleDownload = async (msgID: string, FileName: string, sid: string) => {
  const baseURL = window.location.origin;
  const response = await axios.get(
    `${baseURL}/docsigning/info/inbox/download/${msgID}?SessionID=${sid}`,
    {
      params: {
        filename: FileName,
      },
      responseType: "arraybuffer",
    }
  );
  const pdfData = response.data;

  const blob = new Blob([pdfData], { type: "application/pdf" });
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = FileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export default BuilderDocumentRow;
